import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { memberStatus as memberStatusSelector, isLoggedIn as isLoggedInSelector } from 'redux/saga/selectors/user';
import { selectUserCredits } from 'redux/saga/helpers/credit-cycle';
import { pathSelector } from 'redux/saga/selectors/request';
import { userProfile } from 'redux/saga/entities/bound';
import { Header } from 'components/Header/Header';
import { HeaderUserDetails } from 'components/Header/HeaderUserDetails';
import { PortalDestination } from 'components/Portal/PortalDestination';
import media from 'decorators/Media/Media';
import { CP_LIVE_URL_REGEX } from 'constants/video';
import { CP_GO_URL_REGEX } from 'constants/go';
import { memberStatus as memberStatusEnum } from 'enums/memberStatus';
import { SearchBoxContainer } from 'features/Search/SearchBox/SearchBoxContainer';
import { PATH as SEARCH_PATH } from 'features/Search/Search.route';
import { decorateWith } from 'helpers/decorator';
import * as OptimizelyUtil from 'helpers/optimizely';
import { VENUE_DETAIL_PATH } from 'routes/VenueDetail';
import { NavigationCta } from './NavigationCta';
import { LoggedInUserLinks } from './NavItems/LoggedInUserLinks';
import { Navigation } from './Navigation';
import { CreditCount } from './NavItems/CreditCount';

var mapStateToProps = function mapStateToProps(state) {
  var memberStatus = memberStatusSelector(state);
  var path = pathSelector(state);
  var isLivePage = CP_LIVE_URL_REGEX.test(path);
  var isGoPage = CP_GO_URL_REGEX.test(path);
  var isSearchPage = path.indexOf(SEARCH_PATH) === 0;
  var isVenueDetailPage = path.indexOf(VENUE_DETAIL_PATH) === 0; // search is completed, along with all traces of "_optimizely_search_test"

  var shouldShowSearchOnHomepage = path === '/' && OptimizelyUtil.isActiveVariationFromConfig('searchOnHome');
  return {
    creditsRemaining: selectUserCredits(state).credits_remaining,
    isDark: state.page.darkNav,
    isGoPage: isGoPage,
    isLivePage: isLivePage,
    isSearchPage: isSearchPage,
    isVenueDetailPage: isVenueDetailPage,
    isLoggedIn: isLoggedInSelector(state),
    isMinimal: state.page.reducedNav,
    isTransparentWhenAtScrollTop: false,
    memberStatus: memberStatus,
    path: path,
    showCreditCount: memberStatusEnum('ACTIVE', memberStatus),
    showCta: !state.page.sellHeader && !isLivePage,
    shouldShowSearchOnHomepage: shouldShowSearchOnHomepage,
    user: userProfile.data(state)
  };
};

export var AppHeader =
/*#__PURE__*/
function (_Component) {
  _inherits(AppHeader, _Component);

  function AppHeader() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AppHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AppHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      dropdownExpanded: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleDropdownStateToggled", function () {
      return _this.setState(function (state) {
        return {
          dropdownExpanded: !state.dropdownExpanded
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleNavigation", function () {
      return _this.setState({
        dropdownExpanded: false
      });
    });

    return _this;
  }

  _createClass(AppHeader, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.path !== nextProps.path) {
        this.handleNavigation();
      }
    }
  }, {
    key: "renderSearch",
    value: function renderSearch() {
      var _this$props = this.props,
          isSearchPage = _this$props.isSearchPage,
          isVenueDetailPage = _this$props.isVenueDetailPage,
          mediaQueryLg = _this$props.mediaQueryLg,
          shouldShowSearchOnHomepage = _this$props.shouldShowSearchOnHomepage;
      var shouldRenderSearch = shouldShowSearchOnHomepage || isSearchPage && mediaQueryLg || isVenueDetailPage && mediaQueryLg; // TODO: 'isInHeader' logic should update to include search box in header on search page

      return shouldRenderSearch ? React.createElement("div", {
        className: "header__search"
      }, React.createElement(SearchBoxContainer, {
        isInHeader: shouldShowSearchOnHomepage,
        optimizelyEventTrackingName: shouldShowSearchOnHomepage ? 'Search on Home (nav) click' : null
      })) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isTransparentWhenAtScrollTop = _this$props2.isTransparentWhenAtScrollTop,
          creditsRemaining = _this$props2.creditsRemaining,
          showCreditCount = _this$props2.showCreditCount,
          mediaQueryLg = _this$props2.mediaQueryLg,
          memberStatus = _this$props2.memberStatus,
          isDark = _this$props2.isDark,
          isLoggedIn = _this$props2.isLoggedIn,
          isLivePage = _this$props2.isLivePage,
          isSearchPage = _this$props2.isSearchPage,
          isVenueDetailPage = _this$props2.isVenueDetailPage,
          isGoPage = _this$props2.isGoPage,
          isMinimal = _this$props2.isMinimal,
          showCta = _this$props2.showCta,
          user = _this$props2.user;
      var dropdownExpanded = this.state.dropdownExpanded;
      var navigationProps = {
        user: user,
        isLivePage: isLivePage,
        isGoPage: isGoPage,
        isActiveUser: memberStatusEnum('ACTIVE', memberStatus),
        isUnpaidUser: memberStatusEnum('UNPAID', memberStatus),
        isCancelledUser: memberStatusEnum('CANCELLED', memberStatus),
        isUnsubscribedUser: memberStatusEnum('UNSUBSCRIBED', memberStatus),
        isLoggedIn: isLoggedIn,
        isSearchPage: isSearchPage,
        isVenueDetailPage: isVenueDetailPage
      };
      return React.createElement(Fragment, null, React.createElement(Header, {
        isDark: isDark,
        isTransparentWhenAtScrollTop: isTransparentWhenAtScrollTop,
        onDropdownStateToggled: this.handleDropdownStateToggled,
        dropdownOpen: dropdownExpanded,
        showHamburger: !memberStatus,
        isMobile: !mediaQueryLg
      }, this.renderSearch(), React.createElement("div", {
        className: "header__spacer"
      }), !isMinimal && mediaQueryLg && React.createElement(Navigation, navigationProps), !isMinimal && showCta && React.createElement(NavigationCta, _extends({
        className: isSearchPage ? '_optimizely_search_test' : ''
      }, navigationProps)), React.createElement(PortalDestination, {
        id: "nav-cta"
      }), showCreditCount && React.createElement(CreditCount, {
        creditsRemaining: creditsRemaining
      }), memberStatus && React.createElement(HeaderUserDetails, {
        firstName: user.first_name,
        mediaQueryLg: mediaQueryLg,
        dropdownOpen: dropdownExpanded,
        onDropdownStateToggled: this.handleDropdownStateToggled
      }, React.createElement("ul", null, React.createElement(LoggedInUserLinks, null)))), dropdownExpanded && !mediaQueryLg && React.createElement(Navigation, _extends({}, navigationProps, {
        onClick: this.handleNavigation,
        isMobile: true
      })));
    }
  }]);

  return AppHeader;
}(Component);
AppHeader.propTypes = {
  canViewUnifiedSearch: PropTypes.bool,
  creditsRemaining: PropTypes.number,
  isDark: PropTypes.bool,
  isGoPage: PropTypes.bool,
  isLivePage: PropTypes.bool,
  isSearchPage: PropTypes.bool,
  isVenueDetailPage: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isMinimal: PropTypes.bool,
  isTransparentWhenAtScrollTop: PropTypes.bool,
  mediaQueryLg: PropTypes.bool,
  isClient: PropTypes.bool,
  memberStatus: PropTypes.string,
  path: PropTypes.string.isRequired,
  showCreditCount: PropTypes.bool,
  showCta: PropTypes.bool,
  shouldShowSearchOnHomepage: PropTypes.bool,
  user: PropTypes.object
};
export var AppHeaderContainer = decorateWith(connect(mapStateToProps), media)(AppHeader);